import { render } from "./PurchasingReport.vue?vue&type=template&id=095bd41a&ts=true"
import script from "./PurchasingReport.vue?vue&type=script&lang=ts"
export * from "./PurchasingReport.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__